function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { renderToStaticMarkup } from "react-dom/server";
export const serifList = ["400", "Italic:400", "700", "Italic:700"];
export const sansList = ["300", "Italic:300", "400", "Italic:400", "600", "Italic:600", "700", "Italic:700"];

const SingleFont = _ref => {
  let {
    font,
    weight,
    rel
  } = _ref;
  return /*#__PURE__*/React.createElement("link", _extends({
    href: `https://foundry.churchofjesuschrist.org/Foundry/v1/Ensign:${font === "sans" ? "Sans" : "Serif"}:${weight}/css`,
    rel: rel
  }, rel === "preload" ? {
    as: "style",
    onLoad: event => {
      event.target.rel = "stylesheet";
    }
  } : {}));
};

const Fonts = _ref2 => {
  var _serif$map, _sans$map;

  let {
    serif = serifList,
    sans = sansList,
    rel = "stylesheet"
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://foundry.churchofjesuschrist.org"
  }), serif === null || serif === void 0 ? void 0 : (_serif$map = serif.map) === null || _serif$map === void 0 ? void 0 : _serif$map.call(serif, weight => /*#__PURE__*/React.createElement(SingleFont, {
    key: weight,
    font: "serif",
    weight: weight,
    rel: rel
  })), sans === null || sans === void 0 ? void 0 : (_sans$map = sans.map) === null || _sans$map === void 0 ? void 0 : _sans$map.call(sans, weight => /*#__PURE__*/React.createElement(SingleFont, {
    key: weight,
    font: "sans",
    weight: weight,
    rel: rel
  })));
};

Fonts.propTypes = {
  /** Which serif weights/styles to load. Pass `[]` to get none */
  serif: PropTypes.arrayOf(PropTypes.oneOf(serifList)),

  /** Which sans weights/styles to load. Pass `[]` to get none */
  sans: PropTypes.arrayOf(PropTypes.oneOf(sansList)),

  /** Populates the `rel` attribute. `preload` adds additional attributes to properly handle how preloading needs to be implemented for CSS files */
  rel: PropTypes.oneOf(["preload", "stylesheet"])
};
export default Fonts;
const staticFontsMarkup = renderToStaticMarkup( /*#__PURE__*/React.createElement(Fonts, null));
export { staticFontsMarkup };